import React from 'react'
import { Link } from 'gatsby'
import get from 'lodash/get'
import { useQuery } from '@apollo/react-hooks'
import { PROFILE } from '../gql/auth'
import logo from '../images/icon/logo/white.svg'

import '../styles/header.css'

export default () => {
  const { data, loading, error } = useQuery(PROFILE)

  if (loading || error || !data) {
    return (
      <header className="light-header">
        <Link to="/">
          <img src={logo} alt="proFIT" className="logo" />
        </Link>
      </header>
    )
  }

  const { avatar } = get(data, 'profile', {})
  return (
    <header className="light-header">
      <Link to="/">
        <img src={logo} alt="proFIT" className="logo" />
      </Link>
      <div className="profile-block">
        <img src={avatar} alt="" className="avatar"/>
      </div>
    </header>
  )
}
